import { Paragraph, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

type Props = {
  jobCreatedAt: string;
  jobTitle: string;
  notes: string;
};

const JobInformation = ({ jobCreatedAt, jobTitle, notes }: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        JOB INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            Job Create At :
          </Typography>
          <Typography className="value">{jobCreatedAt}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            Job Title :
          </Typography>
          <Typography className="value">{jobTitle}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title" fontColor="dark">
            Notes :
          </Typography>
          <div className="value">
            <Paragraph numberOfLines={1}>{notes}</Paragraph>
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default JobInformation;
